import { render, staticRenderFns } from "./LoggedUserMobileMenuDialog.vue?vue&type=template&id=3c44294b&"
import script from "./LoggedUserMobileMenuDialog.vue?vue&type=script&lang=js&"
export * from "./LoggedUserMobileMenuDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSecureImg: require('/usr/src/app/components/base/SecureImg.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBottomNavigation,VBtn,VContainer,VDialog,VIcon})
